<template>
  <div class="status_filter">
    <div class="flex flex-between">
      <h5 class="status_filter--label">{{ label }}</h5>

      <div class="status_filter--select_all">
        <button-link
          @click="selectAll"
          class="status_filter--select_all--button"
        >select all
        </button-link>
        <button-link
          @click="deselectAll"
          class="status_filter--select_all--button"
        >deselect all
        </button-link>
      </div>
    </div>

    <div class="status_filter--list">
      <div v-for="option in options" v-show="option.show" :key="option.id">
        <b-checkbox
          v-model="filterValue"
          :native-value="option.id"
          @input="handleInput"
          size="is-small"
        >
          {{ option.label }}
        </b-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterStatusesMultiple",
  props: {
    label: {
      type: String,
      default: "Statuses"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    statusesName: {
      type: String,
      default: "statuses"
    },
    statusStates: {
      type: Array,
      default: []
    },
    initialStatus: Number,
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].statuses
      },
      set(value) {
        this.commitStatus(value)
      }
    },
    statuses() {
      return this.$store.getters["pipeline/statuses"]
    },
    options() {
      /**
       * need show variable just to resolved issue of filter sidebar closing when selecting new items
       * filter sidebar will close if there are newly render DOMs and selecting them
       * */
      const filteredStatuses = this.statuses.map((status) => {
        if (this.statusStates.length !== 0 && this.statusStates.includes(status.state)) {
          return {...status, show: true}
        }

        return {...status, show: false}
      })

      // removes selected status id not included on selected status states
      this.filterValue = this.filterValue.filter((value) => {
        return value !== undefined && filteredStatuses.find(status => status.id === value && status.show)
      })

      return filteredStatuses
    },
    text() {
      if (!this.filterValue.length) return null

      let statusLabelArray = [];

      this.filterValue.forEach(statusId => {
        let status = this.options.find(status => status.id === statusId)
        if (status) {
          statusLabelArray.push(status.label);
        }
      });

      return statusLabelArray.join(", ");
    },
  },
  created() {
    if(this.initialStatus) {
      this.commitStatus([this.initialStatus])
    }

    this.handleInput();
  },
  methods: {
    selectAll() {
      this.filterValue = this.options.map(status => {
        return status.id;
      });
      this.handleInput();
    },
    deselectAll() {
      this.filterValue = [];
      this.handleInput();
    },
    commitStatus(values) {
      this.$store.commit(this.storeModule + "/setOneFilter", [
        this.filterName,
        "statuses",
        values
      ]);
    },
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.status_filter {

  &--label {
    font-size: 0.875rem;
    font-weight: normal;
  }

  &--select_all {
    display: flex;

    &--button {
      margin-left: 10px;
    }
  }

  &--list {
    padding: 8px 4px 0;
  }
}

::v-deep .b-checkbox.checkbox {
  display: flex !important;
  margin-bottom: 4px;
}
</style>
